var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 5L7.42687 8.26414C9.55068 9.4675 10.448 9.4675 12.5718 8.26414L18.3327 5",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67916 11.2297C1.73363 13.7844 1.76087 15.0617 2.70348 16.0079C3.64608 16.9541 4.95796 16.987 7.58171 17.0529C9.19877 17.0936 10.7999 17.0936 12.417 17.0529C15.0408 16.987 16.3526 16.9541 17.2953 16.0079C18.2378 15.0617 18.2651 13.7844 18.3195 11.2297C18.3371 10.4083 18.3371 9.59183 18.3195 8.77042C18.2651 6.2158 18.2378 4.93849 17.2953 3.9923C16.3526 3.04611 15.0408 3.01315 12.417 2.94722C10.7999 2.90659 9.19877 2.90659 7.5817 2.94722C4.95796 3.01313 3.64608 3.04609 2.70347 3.99229C1.76087 4.93848 1.73363 6.21579 1.67915 8.77042C1.66163 9.59183 1.66164 10.4083 1.67916 11.2297Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.abea986d0268ae70f67ec8012c71fd3e.svg";
export { ForwardRef as ReactComponent };